import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { FlexColumn, BaseFlex, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Collapsible } from "@similarweb/ui-components";

export const AdditionsWrapper = styled(BaseFlex)``;

export const StepWrapper = styled(FlexColumn)<{ isOpen: boolean }>`
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #e6e9ec;
    border-radius: 6px;
    background-color: ${({ isOpen }) => (isOpen ? colorsPalettes.carbon[0] : colorsPalettes.bluegrey[100])};
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
    &:hover {
        background-color: ${colorsPalettes.carbon[0]};
        transition: all ease-in-out 0.2s;
        box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    }
`;
export const Body = styled(FlexColumn)`
    padding: 0 24px 24px 62px;
    gap: 24px;
`;
export const CollapsibleWrapper = styled(Collapsible)<{
    isActive: boolean;
    isOpening: boolean;
}>`
    align-self: start;
    width: 100%;
    overflow: ${({ isActive, isOpening }) => (!isActive || isOpening ? "hidden" : "unset")};
    ${({ isActive }) => isActive && `margin-top: -10px;`}
`;
export const Description = styled(BaseFlex)`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
    margin-right: 40px;
`;
export const ButtonsWrapper = styled(FlexRow)`
    justify-content: space-between;
`;
export const ButtonsLeft = styled(FlexRow)`
    gap: 8px;
`;
